import { jsx as _jsx } from "react/jsx-runtime";
import { Typography as MuiTypography, } from '@mui/material';
import { forwardRef, useMemo } from 'react';
import { WithEndDecorator, } from '../../legacy/components';
import { useTheme } from '../../theme';
// exported, but only used in stories
export const typographyVariants = [
    'display',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'button',
    'body1 light',
    'body1 regular',
    'body1 medium',
    'body1 semibold',
    'body2 light',
    'body2 regular',
    'body2 medium',
    'body2 semibold',
    'caption regular',
    'caption medium',
];
// exported, but only used in stories
export const colorVariants = [
    'darkBlue', // #23366F
    'zurichBlue', // #2167AE
    'connect', // #E06717
    'black', // #0D1115
    'white', // #FFFFFF
    'success', // #428351
    'error', // #CB4B40
    'warning', // #F69C00
    'grey8', // #A6ADAF
];
const useColors = (color) => {
    const theme = useTheme();
    const colorMap = useMemo(() => ({
        darkBlue: theme.palette.primary.dark,
        zurichBlue: theme.palette.primary.main,
        connect: theme.palette.groupPrimary.connectOrange,
        black: theme.palette.secondary.dark,
        white: theme.palette.white.main,
        success: theme.palette.success.main,
        error: theme.palette.error.main,
        warning: theme.palette.warning.main,
        grey8: theme.palette.grey[800],
        inherit: 'inherit',
    }), [theme]);
    return colorMap[color];
};
export const Typography = forwardRef(function Typography({ children, variant, align, height, minHeight, maxWidth, color: colorProp = 'black', endDecorator, emptyEndDecorator, ...props }, ref) {
    const { variants } = useTheme().components?.DSTypography ?? {};
    const color = useColors(colorProp);
    return (_jsx(WithEndDecorator, { endDecorator: endDecorator, emptyEndDecorator: emptyEndDecorator, decoratorComponent: _jsx(MuiTypography, { component: getComponentForVariant(variant), ref: ref, height: height, minHeight: minHeight, maxWidth: maxWidth, ...variants?.[variant], color: color, lineHeight: variant === 'button' ? 'inherit' : variants?.[variant]?.lineHeight, align: align, ...props, children: children }) }));
});
function getComponentForVariant(variant) {
    switch (variant) {
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
            return variant;
        default:
            return 'span';
    }
}
